<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('invoices.metadatos.new_metadato')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2 ">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('invoices.metadatos.metadato_campo')}}
              <el-form-item prop="campo">
                <el-select
                  class="w-full"
                  v-model="form.campo"
                  clearable
                  filterable
                  allow-create
                  maxlength='50'
                  @change="onChangeCampo"
                  placeholder="Seleccione un metadato existente o escriba el nombre de uno nuevo y selecciónelo">
                  <el-option
                    v-for="item in listMetadatasClient"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </label>
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('invoices.metadatos.metadato_valor')}}
              <el-form-item prop="valor">
                <el-select
                  v-if="Tipo !== 0"
                  class="w-full"
                  v-model="form.valor"
                  clearable
                  filterable
                  :allow-create="Tipo === 1"
                  maxlength='500'
                  >
                  <el-option
                    v-for="(item, index) in Valores"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                <el-input
                  v-else
                  type="textarea"
                  :rows="3"
                  clearable
                  class="w-full"
                  v-model="form.valor"
                  maxlength="500"
                />
              </el-form-item>
            </label>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button class="w-full" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" type="button"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="uploadNewMetadato('ruleForm')" type="button"/>
    </template>
  </base-dialog>
</template>

<script>
import { i18n } from '@/i18n'

import { agregarMetadatoInvoice } from '@/services/configurations/agregarMetadatoInvoice'
import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'
import { getValoresMetadatoClienteAmpliado } from '@/services/clients/getValoresMetadatoClienteAmpliado'

export default
{
  name: 'invoice-new-metadata-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idFacturae: {
      type: Number,
      default: -1
    },
    idInvoice: {
      type: Number,
      default: -1
    },
    idCliente: {
      type: Number,
      default: -1
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
        campo: '',
        valor: '',
      },
      Tipo: 0,
      Valores: [],
      listMetadatasClient: [],
      rules: {
        campo: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        valor: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          },
        ],
      }
    }
  },
  mounted: async function () {
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (value) {
        this.form.campo = ''
        this.form.valor = ''
        this.EsLista = false
        this.Valores = []
      }
      this.downloadData()
    },
    'form.campo' (value, oldValue) {
      if (value) this.getDataMetadato()
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
  },
  methods: {
    onChangeCampo (value) {
      this.form.campo = value.toLocaleUpperCase().replaceAll(' ', '_')
    },
    getDataMetadato: async function () {
      try {
        this.EsLista = false
        this.Valores = []
        this.form.valor = ''
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: this.form.campo, 
          idCliente: this.idCliente, 
        }
        const response = await getValoresMetadatoClienteAmpliado(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.Tipo = response.Tipo
          this.Valores = response.Valores
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadData: async function () {
      this.listMetadatasClient = []
      const respuestaMetadataClient = await getListMetadatas({ idCliente: this.idCliente })
      if (respuestaMetadataClient.blnError) {
        this.doFeedback(`${respuestaMetadataClient.msgError} [${respuestaMetadataClient.codError}]`)
      } else {
        this.listMetadatasClient = respuestaMetadataClient.Respuesta.map(x => ({ value: x.Campo, label: x.Campo }))
      }
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.form.campo = ''
      this.form.valor = ''
      this.$emit('toggleDialog')
    },
    uploadNewMetadato: async function (ruleForm) {
      try {
        this.$store.commit('setAjaxRequestPending', true)
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            const payload = {
              idFacturae: this.idFacturae,
              idInvoice: this.idInvoice, 
              Campo: this.form.campo, 
              Valor: this.form.valor, 
            }
            const response = await agregarMetadatoInvoice(payload)
            if (response.blnError === true) {
              this.doFeedback(`${response.msgError} [${response.codError}]`)
            } else {
              this.$emit('applyDialog')
              this.doFeedback('Metadato añadido correctamente', 'success')
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 60%;
  border: none;
  padding: 1px;
}

</style>
